<div class="bottom-sheet-wrapper">
  <div class="bottom-sheet-header">
    <span>Tratamento de ponto</span>
    <button class="close-btn" (click)="close()">×</button>
  </div>
  <hr class="divider" />

  <div class="bottom-sheet-options">
    <div class="option-item" *ngFor="let option of bonusReasonRadioOptions">
      <label class="option-item-label">
        <input type="radio" [name]="'bonusReason-' + item?.id" [value]="option.id"
          [(ngModel)]="tempSelectedBonusReasonId" />
        <span class="option-item-title">{{ option.title }}</span>
      </label>
      <button *ngIf="bonusReasonDescriptionTooltip(option.description)" type="button"
        class="btn btn-icon btn-sm bonus-reason-info-btn text-primary" container="body" placement="left"
        tooltipClass="pre-handling-bottom-sheet-tooltip" triggers="mouseenter:mouseleave click:blur"
        [ngbTooltip]="bonusReasonDescriptionTooltip(option.description)" aria-label="Ver descrição da justificativa">
        <i data-feather="info" appFeatherIcon></i>
      </button>
    </div>
  </div>

  <hr class="divider" />
  <div class="bottom-sheet-actions">
    <button class="btn cancel-btn" (click)="close()">Cancelar</button>
    <button class="btn select-btn" (click)="confirmBonusReasonSelection(item)">Selecionar</button>

  </div>
</div>